import styled from '@emotion/styled';
import 'react-datepicker/dist/react-datepicker.css';

export * from 'react-datepicker';

export const ContentWrapper = styled.div`
    flex-wrap: wrap;
    vertical-align: top;
`;

export const DatePickerLabel = styled.p`
    margin: 0;
    padding-right: 1rem;
`;

export const DatePickerWrapper = styled.div`
    margin: 0;
    padding-right: 1rem;
`;